import { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import ReactPaginate from "react-paginate";

function App() {
  const baseUrl = process.env.REACT_APP_API_ENDPOINT;
  const jobTitleUrl = process.env.REACT_APP_API_ENDPOINT_TITLE;

  const [showMenu, setShowMenu] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [jobPosition, setJobPosition] = useState([]);

  // paginação vagas efetivas
  const itemsPerPage = 3;
  const [itemOffsetEffectiveJobs, setItemOffsetEffectiveJobs] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);

  const endOffsetEffectiveJobs = itemOffsetEffectiveJobs + itemsPerPage;

  const currentEffectiveJobs = jobs.slice(
    itemOffsetEffectiveJobs,
    endOffsetEffectiveJobs
  );
  const pageCountEffectiveJobs = Math.ceil(jobs.length / itemsPerPage);

  const handlePageClickEffectiveJobs = (event) => {
    const newOffset = (event.selected * itemsPerPage) % jobs.length;
    setItemOffsetEffectiveJobs(newOffset);
    setCurrentPage(event.selected);

    document.getElementById("oportunidades").scrollIntoView();
  };

  useEffect(() => {
    setShowLoader(true);
    fetch(`${baseUrl}&IsAdHoc=false`)
      .then((response) => response.json())
      .then((data) => {
        setJobs(data.JpPositions);
        setShowLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setShowLoader(false);
      });

    fetch(
      `${jobTitleUrl}&StatusJobPosition=Aberta&StatusAppliance=Aberta&StatusViaLink=ViaLink`,
      {
        headers: {
          API_KEY: process.env.REACT_APP_API_KEY,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setJobPosition([...data]);
      })
      .catch((err) => {
        console.log(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filterJobs = ($event) => {
    document.getElementById("oportunidades").scrollIntoView();
    setShowLoader(true);
    setItemOffsetEffectiveJobs(0);
    setCurrentPage(0);

    const filterValue = Number($event.target.value);
    fetch(`${baseUrl}&JobTitleId=${filterValue}&Sort=true&IsAdHoc=false`)
      .then((response) => response.json())
      .then((data) => {
        setJobs(data.JpPositions);
        setShowLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setShowLoader(false);
      });
  };

  return (
    <div>
      <nav className="bg-transparent h-24 absolute top-0 w-full max-[1024px]:!bg-[#2074D9]">
        <div className="flex items-center justify-between p-4 pr-[10%] relative max-[1024px]:justify-center">
          <div>
            <img
              src="./assets/images/logo-randstad-white.svg"
              alt="Randstad Logo"
              className="h-26"
            />
          </div>

          <ul
            id="content-burger-menu"
            className={`${"flex flex-row justify-end items-center gap-16 list-meu w-1/2"} ${
              showMenu ? "show" : ""
            }`}
          >
            <li>
              <a href="#sobre" className="text-white">
                sobre nós
              </a>
            </li>
            <li>
              <a href="#oportunidades" className="text-white">
                oportunidades
              </a>
            </li>
            <li className="pr-[10%]">
              <a
                href="https://www.randstad.com.br/contate-nos/contato-candidato/"
                target="_blank"
                className="text-white"
                rel="noreferrer"
              >
                contato
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <div className="w-full h-auto flex max-[1024px]:pt-[6rem]">
        <div className="w-full max-[1024px]:hidden">
          <img
            src="./assets/images/banner_main.png"
            alt="Randstad Digital Landing Page PCD"
            className="w-full h-full rounded-none"
          />
          <div className="absolute top-[45%] left-[5%] p-4">
            <h1 className="text-[80px] text-white">juntos pela inclusão</h1>
            <p className="text-3xl text-white ml-[36%] !font-[GraphikLight]">
              cadastre-se no nosso banco de talentos para pessoas com
              deficiência
            </p>
          </div>
        </div>
        <div className="w-full relative hidden max-[1024px]:flex">
          <img
            src="./assets/images/banner_mobile.png"
            alt="Randstad Digital Landing Page PCD"
            className="w-full rounded-none"
          />
          <div className="absolute bottom-0 left-8 p-4">
            <h1 className="text-[40px] text-white">juntos pela</h1>
            <h1 className="text-[40px] text-white ml-28">inclusão</h1>
            <p className="text-xl text-white !font-[GraphikLight]">
              cadastre-se no nosso banco de talentos para pessoas com
              deficiência
            </p>
          </div>
        </div>
      </div>

      <div
        id="sobre"
        className="flex flex-col py-36 px-[12vw] max-[1024px]:py-16 max-[1024px]:px-[7vw]"
      >
        <h1 className="text-6xl text-blue-500 mb-6 max-[1024px]:text-4xl">
          afinal, quem é a Randstad?
        </h1>
        <p>
          A Randstad é líder global em recrutamento e soluções de RH. Atuamos em
          todas as etapas da jornada profissional, desde recrutamento e seleção
          para diferentes níveis e formatos de trabalho, até onboarding e
          offboarding. Nosso propósito é impulsionar talentos e apoiar empresas
          em seus desafios de gestão de pessoas, em um mundo do trabalho em
          constante transformação. Fundada em 1960, na Holanda, estamos
          presentes em 39 países, incluindo o Brasil. <br /> Nosso time de
          Recrutamento & Seleção, aqui chamamos de Talent Acquisition, acompanha
          todos os currículos que são cadastrados em nossa plataforma. Por isso,
          fique atento(a) ao seu e-mail e telefone, pois entraremos em contato
          assim que surgir uma oportunidade compatível com o seu perfil.
        </p>
        <div className="flex justify-between items-center bg-[#2175D9] w-full mt-5 px-4 py-12 max-[1024px]:flex-col">
          <div className="flex flex-col w-[55%] max-[1024px]:w-full">
            <h1 className="text-6xl text-white mb-6 max-[1024px]:text-4xl">
              nosso compromisso
            </h1>
            <p className="text-white">
              Acreditamos que a diversidade torna as equipes mais fortes. Nosso
              objetivo com este Banco de Talentos é promover, todos os dias, um
              ambiente de trabalho diverso, inclusivo e acolhedor, onde o
              respeito e a valorização das pessoas estão presentes em todas as
              nossas relações.
            </p>
          </div>
          <div className="w-[40%] max-[1024px]:w-full max-[1024px]:mt-4">
            <img
              src="./assets/images/banner3.png"
              alt="Etapa 01"
              className=""
            />
          </div>
        </div>
      </div>

      <div className="relative pb-14 px-[7vw] max-[1024px]:hidden">
        <img src="./assets/images/Pcd0.png" alt="image_Pcd" className="" />
        <div className="absolute right-0 top-0 pb-14 px-[9vw] h-full w-[50%] flex flex-col justify-center">
          <h1 className="text-[#00D7FF] text-[60px] max-[1368px]:text-[40px]">
            juntos pela inclusão:
          </h1>
          <h2 className="text-[#00D7FF] text-3xl max-[1368px]:text-2xl">
            cadastre-se no nosso banco de talentos para pessoas com deficiência
          </h2>
          <p className="text-white my-3 max-[1368px]:text-sm">
            Seu talento é único. Suas oportunidades também devem ser. Na
            Randstad, acreditamos que a diversidade fortalece equipes,
            impulsiona a inovação e transforma o ambiente de trabalho em um
            espaço mais justo, humano e produtivo. Por isso, estamos construindo
            um banco de talentos exclusivo para profissionais com deficiência —
            e queremos conhecer você!
          </p>
          <button className="self-center bg-[#2175D9] text-white mt-[3%] rounded-md hover:bg-blue-600 w-[337px] h-[67px]">
            <a
              href="#oportunidades"
              className="flex justify-center items-center h-full w-full"
            >
              cadastre seu currículo
            </a>
          </button>
        </div>
      </div>

      <div className="hidden px-[7vw] max-[1024px]:flex flex-col">
        <div className="bg-[#0F1941] w-full flex flex-col justify-center p-6">
          <h1 className="text-[#00D7FF] text-[40px]">juntos pela inclusão:</h1>
          <h2 className="text-[#00D7FF] text-2xl">
            cadastre-se no nosso banco de talentos para pessoas com deficiência
          </h2>
          <p className="text-white my-3 text-sm">
            Seu talento é único. Suas oportunidades também devem ser. Na
            Randstad, acreditamos que a diversidade fortalece equipes,
            impulsiona a inovação e transforma o ambiente de trabalho em um
            espaço mais justo, humano e produtivo. Por isso, estamos construindo
            um banco de talentos exclusivo para profissionais com deficiência —
            e queremos conhecer você!
          </p>
          <button className="self-center bg-[#2175D9] text-white mt-[3%] rounded-md hover:bg-blue-600 w-[337px] h-[67px] max-[1024px]:w-full">
            <a
              href="#oportunidades"
              className="flex justify-center items-center h-full w-full"
            >
              cadastre seu currículo
            </a>
          </button>
        </div>
        <img
          src="./assets/images/Pcd0_mobile.png"
          alt="image_Pcd"
          className="rounded-none"
        />
      </div>

      <div className="flex justify-between py-16 px-[7vw] max-[1024px]:flex-col">
        <div className="w-[47%] pr-4 max-[1024px]:w-full max-[1024px]:pr-0">
          <h1 className="text-6xl text-blue-500 mb-6 max-[1024px]:text-4xl">
            conexões que vão além do agora.
          </h1>
          <p>
            Pensando em ampliar a inclusão de pessoas com deficiência no mercado
            de trabalho, criamos um Banco de Talentos exclusivo para
            profissionais PcD, com vagas em diversas áreas. <br />
            <br /> Ao se cadastrar no nosso banco de talentos, você terá acesso
            a uma ampla variedade de oportunidades profissionais. As vagas podem
            ser para compor o nosso time interno, mas também para atuar em
            empresas parceiras que confiam em nosso trabalho de recrutamento
            inclusivo. Nossos clientes estão presentes em diversos segmentos —
            como tecnologia, varejo, indústria, serviços e muito mais — e variam
            desde startups em crescimento até grandes corporações consolidadas
            no mercado. <br />
            <br /> Essa diversidade amplia significativamente suas
            possibilidades de carreira, permitindo que você encontre uma vaga
            que esteja alinhada com seu perfil, seus objetivos e seu estilo de
            vida.
          </p>
        </div>
        <div className="w-[52%] max-[1024px]:w-full max-[1024px]:mt-8">
          <img
            src="./assets/images/Pcd2.png"
            alt="Banner 02"
            className="w-full h-full"
          />
        </div>
      </div>

      <div className="w-full flex flex-col justify-center py-16 px-[7vw] max-[1024px]:py-0">
        <h1 className="text-6xl text-blue-500 mb-8 max-[1024px]:text-4xl max-[1024px]:!text-left">
          banco de talentos de um modo descomplicado
        </h1>
        <p className="mb-4 max-[1024px]:px-0 max-[1024px]:!text-left">
          É uma plataforma online onde reunimos currículos de profissionais com
          deficiência. Isso facilita o processo de recrutamento e fortalece a
          inclusão, conectando empresas que valorizam a diversidade a talentos
          PcD alinhados às exigências de cada vaga.
        </p>

        <div className="flex justify-between w-full mb-5 max-[1024px]:flex-col">
          <img
            src="./assets/images/etapa1.svg"
            alt="Etapa 01"
            className="w-[32%] max-[1024px]:w-full"
          />
          <img
            src="./assets/images/etapa2.svg"
            alt="Etapa 02"
            className="w-[33%] max-[1024px]:w-full"
          />
          <img
            src="./assets/images/etapa3.svg"
            alt="Etapa 01"
            className="w-[32%] max-[1024px]:w-full"
          />
        </div>
        <button className="bg-[#2175D9] text-white mt-[3%] rounded-md hover:bg-blue-600 h-[62px] w-[244px] max-[1024px]:w-full self-center">
          <a
            href="#oportunidades"
            className="flex justify-center items-center w-full h-full"
          >
            cadastre-se agora
          </a>
        </button>
      </div>

      <div
        className="w-full flex flex-col justify-center py-14 px-[7vw]"
        id="oportunidades"
      >
        <h1 className="text-6xl text-blue-500 mb-4 max-[1024px]:text-4xl">
          quer fazer parte?
        </h1>
        <p className="mb-4">
          Se você tem interesse em trabalhar conosco, inscreva-se aqui! Nosso
          time de Talent Acquisition analisará seu perfil com atenção e cuidado.
        </p>
        <select
          onChange={filterJobs}
          id="filter-btn"
          className="w-[350px] mb-4 p-2 cursor-pointer max-[768px]:w-full"
        >
          <option value="">Todas</option>
          {jobPosition.map((jobId, i) => (
            <option value={jobId.TitlePositionId} key={i}>
              {jobId.TitleName}
            </option>
          ))}
        </select>
        {showLoader && (
          <div className="w-[90%] flex flex-col items-center mt-20 max-[768px]:w-full">
            <Spinner animation="grow" variant="primary" />
            <h4 className="text-[#3b82f6] mt-4">Carregando</h4>
          </div>
        )}
        {!showLoader && currentEffectiveJobs.length ? (
          <>
            <ul>
              {currentEffectiveJobs.map((job, i) => (
                <li className="jobs-list" key={i}>
                  <div className="w-[70%] pl-3 max-[768px]:w-full max-[768px]:p-0">
                    <p className="!m-0 max-[768px]:text-center">{job.Name}</p>
                  </div>
                  <div className="w-[30%] flex justify-end max-[768px]:w-full max-[768px]:justify-center">
                    <Button
                      className="py-3 px-5 cursor-pointer self-end"
                      variant="primary"
                      href={job.ShortUrl}
                      target="_blank"
                    >
                      candidatar-se
                    </Button>
                  </div>
                </li>
              ))}
            </ul>
            <ReactPaginate
              containerClassName="pagination"
              breakLabel="..."
              nextLabel="Próximo >"
              onPageChange={handlePageClickEffectiveJobs}
              marginPagesDisplayed={2}
              pageCount={pageCountEffectiveJobs}
              forcePage={currentPage}
              previousLabel="< Anterior"
              renderOnZeroPageCount={null}
            />
          </>
        ) : null}
        {!showLoader && !currentEffectiveJobs.length ? (
          <div className="jobs-list !justify-center">
            <h2 className="text-xl">
              Não encontramos resultados para sua busca.
            </h2>
          </div>
        ) : null}
      </div>

      <div className="flex flex-col gap-3 bg-[#f7f5f0] px-[7vw] py-16 max-[1024px]:items-center">
        <p className="text-black text-2xl mb-2">
          buscando dicas para a sua carreira? confira nosso blog
        </p>
        <a
          href="https://www.randstad.com.br/guia-carreira/"
          target="_blank"
          className="w-[230px] text-center border-[2px] border-solid !border-blue-500 text-blue-500 py-3 px-6 rounded-[4px] hover:bg-blue-500 hover:text-white transition"
          rel="noreferrer"
        >
          acesse nosso blog
        </a>
      </div>

      <footer className="bg-[#2074D9] text-white py-8">
        <div className="container mx-auto flex flex-col items-center md:flex-row md:justify-between px-4">
          <div className="mb-4 md:mb-0">
            <img
              src="./assets/icons/Logo.png"
              alt="Randstad Logo"
              className="h-12"
            />
          </div>

          <div className="text-center md:text-left mb-4 md:mb-0">
            <p className="mb-2">
              Randstad Brasil Recursos Humanos LTDA é uma empresa registrada no
              Brasil sob CNPJ 03.573.863/000
            </p>
            <p>
              Escritório da matriz encontra-se na Av. Francisco Matarazzo, 1350,
              20º andar / CEP: 05001-100
            </p>
          </div>

          <div className="flex space-x-4">
            <a
              href="https://www.linkedin.com/company/randstad-brasil/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/linkedin.svg" alt="Linkedin Logo" />
            </a>
            <a
              href="https://www.youtube.com/user/randstadbrasil/featured"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/youtube.svg" alt="Youtube Logo" />
            </a>
            <a
              href="https://www.facebook.com/RandstadBR/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/facebook.svg" alt="Facebook Logo" />
            </a>
            <a
              href="https://www.instagram.com/randstadbr/"
              target="_blank"
              className="w-8 h-8 flex items-center justify-center"
              rel="noreferrer"
            >
              <img src="./assets/icons/instagram.svg" alt="Instagram Logo" />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
